module.exports = __webpack_public_path__ + "static/media/bank.07b2918a.png";